import type { Person } from "../../models/types";
import { EncryptedPhoto } from "./EncryptedPhoto";

interface AvatarProps {
  person: Person;
  size?: number;
  ring?: boolean;
}

export function Avatar({ person, size = 56, ring = false }: AvatarProps) {
  return (
    <EncryptedPhoto
      stem={person.photo}
      alt={person.display_name}
      className={`avatar ${ring ? "avatar-ring" : ""}`}
      style={{ width: size, height: size, minWidth: size, minHeight: size }}
      fallbackLabel={person.display_name}
    />
  );
}
